export const GET_USER_PROJECTS_REQUEST = 'GET_USER_PROJECTS_REQUEST'
export const GET_USER_PROJECTS_SUCCESS = 'GET_USER_PROJECTS_SUCCESS'
export const GET_USER_PROJECTS_FAILURE = 'GET_USER_PROJECTS_FAILURE'
export const SET_ACTIVE_PROJECT_REQUEST = 'SET_ACTIVE_PROJECT_REQUEST'
export const SET_ACTIVE_PROJECT_SUCCESS = 'SET_ACTIVE_PROJECT_SUCCESS'
export const SET_ACTIVE_PROJECT_FAILURE = 'SET_ACTIVE_PROJECT_FAILURE'
export const CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST'
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS'
export const CREATE_PROJECT_FAILURE = 'CREATE_PROJECT_FAILURE'
export const READ_PROJECT_REQUEST = 'READ_PROJECT_REQUEST'
export const READ_PROJECT_SUCCESS = 'READ_PROJECT_SUCCESS'
export const READ_PROJECT_FAILURE = 'READ_PROJECT_FAILURE'
export const UPDATE_PROJECT_REQUEST = 'UPDATE_PROJECT_REQUEST'
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS'
export const UPDATE_PROJECT_FAILURE = 'UPDATE_PROJECT_FAILURE'
export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST'
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS'
export const DELETE_PROJECT_FAILURE = 'DELETE_PROJECT_FAILURE'
export const PROJECT_ADD_TEAM_REQUEST = 'PROJECT_ADD_TEAM_REQUEST'
export const PROJECT_ADD_TEAM_SUCCESS = 'PROJECT_ADD_TEAM_SUCCESS'
export const PROJECT_ADD_TEAM_FAILURE = 'PROJECT_ADD_TEAM_FAILURE'
export const PROJECT_REMOVE_TEAM_REQUEST = 'PROJECT_REMOVE_TEAM_REQUEST'
export const PROJECT_REMOVE_TEAM_SUCCESS = 'PROJECT_REMOVE_TEAM_SUCCESS'
export const PROJECT_REMOVE_TEAM_FAILURE = 'PROJECT_REMOVE_TEAM_FAILURE'
